import {
    getQueryParams,
    getQueryParamsValues,
} from "../../../../../../magnolia-component-library/assets/js/utils/queryParams";

export const queryParams = getQueryParams();

export const getFiltersValuesFromQueryParams = (queryParams, filters) => {
    const queryValues = getQueryParamsValues(queryParams);
    const filtersValues = {};

    for (const [queryKey, queryValue] of Object.entries(queryValues)) {
        let qv = queryValue;
        const filterType = filters[queryKey] ? filters[queryKey].filterType : null;

        if (filterType && filterType === "checkbox") qv = qv.split(",");

        filtersValues[queryKey] = qv;
    }

    return filtersValues;
};
